export default {
  default_program_name: 'Clubul de recompense',
  message:
    'Alătură-te <highlight>{{name}}</highlight> — câștigă {{reward}} pentru fiecare {{spend}} cheltuiți & deblochează produse gratuite din meniu!',
  buttons: {
    join_now: 'Alătură-te acum',
  },
};
